import * as React from 'react';
import {connect} from 'react-redux';
import {updateGloop} from "../../actions/update";
import { Rnd } from "react-rnd";
import {TextControleComponent} from "./controls/TextControle";
import {loading, incrementVideoVersion} from "../../actions/ui";

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};


class AnimationBlockComponent extends React.Component {
	myRef = React.createRef();

	state = {
		size : '28px',
		mutedVideo: true,
		fieldFocused: false
	};

	constructor(props) {
		super(props);
	}

	getFontList(){
		const {options} = this.props;
		let fonts = (options.data.fonts ? options.data.fonts : '').split(';');
		fonts = fonts.filter(item => item );
		fonts = fonts.map((item)=>{
			if(!item){
				return null;
			}
			let temp = item.split('|')
			if(temp.length>1){
				return {
					title : temp[0],
					font : temp[1]
				}
			}else {
				return {
					title : temp[0],
					font : temp[0]
				}
			}
		});
		return fonts;
	}

	calculateFontSize = () =>{
		const {gloop = {}} = this.props;
		const {data = {}} = gloop;
		let text = data.customized_text? data.customized_text : ''
		const textarea = this.myRef.current;
		text = textarea ? textarea.value : text;
		const length = text.length;
		if(textarea && length){
			const width = textarea.clientWidth;
			const height = textarea.clientHeight;
			let size = Math.floor(
				Math.sqrt(width * height / length) / 1.05
			);
			return size;
		}else {
			return 28;
		}
	}

	render() {
		const {ui,options, gloop = {}, videoVersion,_on} = this.props;
		if(_on){
			this.state.mutedVideo = false;
			this.props._on= false;
		}
		const {data = {}} = gloop;
		if(!options || !gloop){
			return '';
		}
		const colors = [
			'#000',
			'#fff',
			'#00C9A7',
			'#845EC2',
			'#C34A36',
			'#4B4453',
			'#f00',
			'#0f0',
			'#00f',
			'#ff0'
		];
		let fonts = this.getFontList();
		let font = data.font  ? data.font : fonts[0].font;
		let color = data.color ? data.color : colors[0];
		const textWidth = data.textWidth ? data.textWidth : 200;
		const textHeight = data.textHeight ? data.textHeight : 200;
		const xoffset = data.xoffset ? data.xoffset : 0;
		const size = data.size ? data.size : 28;
		const yoffset = data.yoffset ? data.yoffset : 0;
		const text = data.customized_text? data.customized_text.split('|')[0] : '';
		var textareaStyle = {
			color: color,
			cursor: this.state.fieldFocused ? 'text' : 'move',
			'font-family': '"'+font+'", sans-serif',
			'font-size' : (size / 1.40) + 'px'
		};
		let videoUrl = ui.activeTab == 'textcontrol' ?  data.customization_url.replace('.mp4','_no-text.mp4'): data.customization_url
		if(!videoUrl){
			videoUrl =  options.data.v
		}
		videoUrl = videoUrl.replace('/download.user-toings.toing.io/','/user-toings.toing.io/');
		return (
			<div className={'gloop-animation-block'}>
				<div className={'gloop-textarea-block'}>
					{!ui.loading || true ?
						<video
							onError={(event) => {
								loading();
								incrementVideoVersion();
								setTimeout( () => {
									loading(false);
								},2500);
							}}
							onPlay={()=>{
								setTimeout(()=>{
									loading(false);
								},300)

							}}
							// poster={window.humbnail_url}
							key={videoVersion}
							autoPlay={true}
							width={375}
							loop={true}
							muted={this.state.mutedVideo}
							playsinline=""
							controls={false}
							type="video/mp4"
						>
							<source type="video/mp4" src={videoUrl + '?ver='+videoVersion} />
							{/*<source src={data.customization_url+'?ver='+Math.round(Math.random()*100000)} />*/}
							{/*{*/}
							{/*	ui.activeTab == 'textcontrol' ?*/}
							{/*		<source type="video/mp4" src={videoUrl + '?ver='+videoVersion} /> :*/}
							{/*		<source type="video/mp4" src={data.customization_url + '?ver='+videoVersion} />*/}
							{/*}*/}
						</video>
						: '' }
				{ui.activeTab == 'textcontrol' ? (
					 <Rnd
					    style={style}
					    bounds = {'parent'}
					    default={{
					       x: ((xoffset) / 1.92) -10 /*-25*/,
					       y: ((yoffset) /1.92) - 10 /*-10*/,

					      width: textWidth / 1.92 /*+40*/,
					      height: textHeight / 1.92 /*+40*/
					    }}
					    size = {{
					    	width: textWidth / 1.92 /*+ 40*/,
					        height: textHeight / 1.92 /*+40*/
					    }}
					    minWidth = {50}
					    minHeight = {50}
					    // maxWidth = {200}
					    // maxHeight = {200}
					    disableDragging ={this.state.fieldFocused ? true : false}
						 enableUserSelectHack = {false}

					    onResizeStop = {(
						    e,
						    dir,
						    refToElement,
						    delta,
						    position,
					    ) => {
					    	updateGloop({
								textWidth : (refToElement.clientWidth /*-60*/) * 1.92/* +24*/,
					            textHeight : (refToElement.clientHeight /*-60*/) * 1.92/* +24*/,
							    size : this.calculateFontSize() * 1.54,
							    // xoffset : (position.x + 8/*+28*/) *1.92 -4,
							    // yoffset : (position.y + 8/*+10*/) *1.92 -4
							    xoffset : (position.x + 10/*+28*/) *1.92,
							    yoffset : (position.y + 10/*+10*/) *1.92
							},false);
					    }}
					    onDragStop = {(
							 node,
							 position
						 ) => {
					    	 if (position.x != xoffset && position.y != yoffset) {
							    updateGloop({
								    xoffset: (position.x + 10/*+28*/)*1.92 /*-4*/,
								    yoffset: (position.y + 10/*+10*/)*1.92 /*-4*/,
								    //size : this.calculateFontSize() * 1.40,
							    }, false);
						    }
					    }}
					  >
					<div className={'gloop-textarea-holder'}>
						<div className="gloop-textarea-frame">
							<div className={'label'}>
								<span>Tap to edit</span>
							</div>
							<textarea ref={this.myRef} cols={'4'}
							          // rows={'3'}
							          style={textareaStyle}
							          onMouseEnter={(e) => {
							          	this.setState({
											  fieldFocused: true
										  });
							          }}
							          onMouseLeave={(e) =>{
							          	this.setState({
											  fieldFocused: false
										  });
							          }}
									  onBlur={(e) => {
										  this.setState({
											  fieldFocused: false
										  });
										  if (e.target.startValue != e.target.value) {
											  updateGloop({
												  customized_text: e.target.value,
												  size: this.calculateFontSize() * 1.54
											  }, false);
										  }

									  }}
									  onFocus={(e) => {
										  e.target.startValue = e.target.value;
										  // updateGloop({
										  // 	customized_text : e.target.value,
										  //     size : this.calculateFontSize() * 2
										  // },false);
									  }}
							          onKeyUp={() => {

							          	 this.setState({
										 	size : this.calculateFontSize() * 1.54
										 })
							          }}
							>{text}</textarea>
						</div>
					</div>
					 </Rnd>

				): null}
				<div className={'volume-wrapper'} onClick={(e)=>{
					this.setState({
						mutedVideo : !this.state.mutedVideo
					})
				}}
				><div className={'volume-button' + (this.state.mutedVideo ? '' : ' sound')}></div></div>
				</div>
			</div>
		)
	}
	componentDidUpdate(prevProps, prevState) {
		let _on = this.props.ui.activeTab == 'soundcontrol' && (prevProps.ui && prevProps.ui.activeTab!= this.props.ui.activeTab)
		this.props._on = _on;
	}
}
const mapStateToProps = (state,ownProps) => {
	const gloop = state.gloops[state.activeGloop];
	let options = null;
	if(gloop && gloop.data){
		options = state.gloopsOptions[gloop.data.original_gloop[0]]
	}
	return {
		ui: state.ui,
		_on : false,
		gloop : gloop,
		options : options,
		videoVersion : state.videoVersion
	};
}
const AnimationBlock = connect(mapStateToProps)(AnimationBlockComponent)
export default AnimationBlock;
